import { Injectable, Injector } from "@angular/core"
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from "@angular/common/http"
import { Observable } from "rxjs"
import { JwtTokenService } from "./jwt.service"

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    token: string

    constructor(
        private jwt: JwtTokenService
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        this.token = this.jwt.getToken();

        let authRequest
        authRequest = request.clone(
            {
                setHeaders: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE',
                    'Access-Control-Allow-Headers': 'Origin, Authorization',
                    'Authorization': `Bearer ${this.token}`,
                    'version': '1.0.0'
                }
            }
        )
        //console.log(authRequest.url)

        return next.handle(authRequest)
    }





}